export default function CheckButton({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: () => void;
}) {
  return (
    <div className="flex">
      <label
        className={`select-none cursor-pointer rounded-sm p-2 text-xs ${
          checked ? "bg-blue-500 text-white" : ""
        }`}
      >
        <input
          type="checkbox"
          className="hidden"
          checked={checked}
          onChange={onChange}
        />
        {label}
      </label>
    </div>
  );
}
